import { Epic } from '../types';

/**
 * Clamp a number between min and max values
 */
export function clamp(n: number, min: number, max: number): number {
    return Math.max(min, Math.min(max, n));
}

/**
 * Lane-based time criticality modifiers
 */
const LANE_TIME_MODIFIERS: Record<string, number> = {
    Now: 2,
    Next: 0,
    Later: -1,
    Unassigned: 0
};

export function calculateCoD(epic: Partial<Epic>): number {
    const s = Number(epic.security) || 0;
    const b = Number(epic.business) || 0;
    const t = Number(epic.time) || 0;
    const o = Number(epic.ops) || 0;
    const c = Number(epic.confidence) || 1;

    const timeBonus = LANE_TIME_MODIFIERS[epic.lane || 'Unassigned'] || 0;
    const adjustedTime = clamp(t + timeBonus, 1, 5);

    return (s + b + adjustedTime + o) * c;
}

export function scoreEpic(epic: Epic): Epic & { cod: number; wsjf: number; adjustedTime: number; timeBonus: number } {
    const s = Number(epic.security) || 0;
    const b = Number(epic.business) || 0;
    const t = Number(epic.time) || 0;
    const o = Number(epic.ops) || 0;
    const c = Number(epic.confidence) || 1;
    const e = Number(epic.effort) || 1;

    const timeBonus = LANE_TIME_MODIFIERS[epic.lane] || 0;
    const adjustedTime = clamp(t + timeBonus, 1, 5);

    const cod = (s + b + adjustedTime + o) * c;
    const wsjf = cod / e;

    return { ...epic, cod, wsjf, adjustedTime, timeBonus };
}

export function getTrendIndicator(current: number | undefined, previous: number | undefined): { icon: string; color: string; delta: number } {
    if (previous === undefined || previous === null || current === undefined) {
        return { icon: "→", color: "text-slate-400", delta: 0 };
    }

    const delta = current - previous;

    if (delta > 0.1) return { icon: "↑", color: "text-emerald-600", delta };
    if (delta < -0.1) return { icon: "↓", color: "text-rose-600", delta };
    return { icon: "→", color: "text-slate-400", delta: 0 };
}

export function formatDate(dateStr: string | undefined): string {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
}

export function downloadText(filename: string, text: string, mime = "text/plain") {
    const blob = new Blob([text], { type: mime });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 0);
}
